import { FUNNEL_META_SESSION_STORAGE_KEY } from "@/services/storage";
import { getData, setData } from "@/services/storage/session-storage";

import type { FunnelMeta } from "./config";
import { steps } from "./config";

export function isBuilderStep(step: keyof typeof steps) {
  return typeof steps[step] === "string";
}

export function setFunnelMeta(data: FunnelMeta) {
  setData(FUNNEL_META_SESSION_STORAGE_KEY, data);
}

export function getFunnelMeta() {
  const funnelMeta =
    (getData(FUNNEL_META_SESSION_STORAGE_KEY) as FunnelMeta) || {};

  return funnelMeta;
}

export function saveToFunnelMeta(data: Partial<FunnelMeta>) {
  const funnelMeta = getFunnelMeta();
  setFunnelMeta({ ...funnelMeta, ...data });
}

// Preserve any existing query parameters, including "allow-funnel", which prevents
// users from being redirected away from the funnel to the pre-client portal
export function prepareNextPathname({
  practice,
  subPractice,
  nextStep,
}: {
  nextStep?: string;
  practice?: string;
  subPractice?: string;
}) {
  const path = [practice, subPractice, nextStep].filter(Boolean).join("/");

  return `/v2/funnel/${path}${window.location.search}`;
}
